import { compactDecrypt, CompactEncrypt, importJWK, JWK } from "jose";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";

import { safeParse } from "utils/safeJson";
import warning from "utils/warning";

abstract class JweManager {
  private static JWE_PUBLIC_KEY: JWK;
  private static JWE_PRIVATE_KEY: JWK;

  private static ensureKeys() {
    if (!this.JWE_PUBLIC_KEY || !this.JWE_PRIVATE_KEY) {
      const publicKey = getEnvs((state) => state.api_public_key);
      const privateKey = getEnvs((state) => state.api_private_key);
      if (!publicKey || !privateKey) throw new Error("Missing JWE keys");
      this.JWE_PUBLIC_KEY = JSON.parse(publicKey);
      this.JWE_PRIVATE_KEY = JSON.parse(privateKey);
    }
  }

  public static encrypt = async (data: any) => {
    try {
      this.ensureKeys();
      const jwk = await importJWK(
        this.JWE_PUBLIC_KEY as unknown as JWK,
        "RSA-OAEP",
      );

      const jwe = await new CompactEncrypt(
        new TextEncoder().encode(JSON.stringify(data)),
      )
        .setProtectedHeader({ alg: "RSA-OAEP", enc: "A128CBC-HS256" })
        .encrypt(jwk);

      return jwe;
    } catch (err) {
      warning(err);
      return data;
    }
  };

  public static decrypt = async (encryptedData: any) => {
    let data = encryptedData;
    try {
      this.ensureKeys();
      const jwk = await importJWK(
        this.JWE_PRIVATE_KEY as unknown as JWK,
        "RSA-OAEP",
      );

      const { plaintext } = await compactDecrypt(encryptedData, jwk);

      data = new TextDecoder().decode(plaintext);
      data = safeParse(data);
    } catch (err) {
      warning(err);
    } finally {
      return data;
    }
  };
}

export default JweManager;
